import {NEW_ID} from '../../../../common/constants/index.js'
import ButtonPrimary from '../../../../common/components/Button/ButtonPrimary.js'
import ButtonSecondary from '../../../../common/components/Button/ButtonSecondary.js'
import {getState, onlyIfAutoForm, useSelector} from '../../../../store.js'
import Archive from './Archive.js'
import Nickname from './Nickname.js'
import ShippingMethods from './ShippingMethods.js'
import {
  baseShipperFormErrorsSelector,
  baseShipperInitialFormSelector,
  goToShipperSettings,
  simpleSaveShipper,
} from '../ShippersFunctions.js'
import {AMAZON_SFP} from '../../../../common/constants/ShipperNames.js'

export function setUpShipperForm({shipper, formName}) {
  return {
    formName,
    initialForm: {
      ...initialFormSelector(getState(), {shipper}),
      errorsSelector,
    },
  }
}

export function errorsSelector(state, {formName}) {
  return baseShipperFormErrorsSelector(state, {formName})
}

export function initialFormSelector(state, {shipper}) {
  return baseShipperInitialFormSelector(state, {
    shipper,
    vendor: AMAZON_SFP,
  })
}

export async function saveShipperAmazonSFP(formName) {
  return simpleSaveShipper(formName)
}

function AmazonSFPForm({formName, form}) {
  const {id, isSaving} = form
  const errors = useSelector((state) => form.errorsSelector(state, {formName}))

  return (
    <div className="settings-list-item-form-wrap clear-both">
      <div className="medium-6 columns">
        <fieldset>
          <ul className="form-list margin-bottom-0">
            {id !== NEW_ID && (
              <>
                <Nickname formName={formName} />
                <ShippingMethods formName={formName} />
              </>
            )}
            <li className="list__item list__item--no-style">
              <ButtonPrimary
                isLoading={isSaving}
                isDisabled={errors.preventSave}
                onClick={() => saveShipperAmazonSFP(formName)}
              >
                {id !== NEW_ID ? 'Save' : 'Create'}
              </ButtonPrimary>
              <ButtonSecondary onClick={() => goToShipperSettings()}>
                Cancel
              </ButtonSecondary>
            </li>
          </ul>
        </fieldset>
      </div>

      {id !== NEW_ID && (
        <div className="medium-5 columns">
          <div className="alert margin-bottom-10 alert--standard">
            <Archive formName={formName} />
          </div>
        </div>
      )}
    </div>
  )
}

export default onlyIfAutoForm(AmazonSFPForm, setUpShipperForm)
